import { DateTime } from "luxon";
import { getDepartmentWageConfig } from "../../utils/DepartmentWage.config";
import {
	DEFAULT_ALLOWED_HOLIDAYS,
	DEFAULT_WEEK_START_DAY,
	DepartmentType,
	RemoveUnionStaffWarning,
	ShiftType,
	StatsMode,
	uniformHppdTarget,
} from "../../utils/models";
import type { Department } from "../AuthProvider";

export const DEFAULT_CHOSEN_DEPARTMENT = {
	has_intermediate: false,
	department_id: "",
	hospital: "",
	timezone: "",
	target_ppn: 0,
	total_beds: 0,
	display_name: "",
	name: "",
	locations: [],
	start_date: DateTime.now(),
	first_sunday: DateTime.now(),
	type: DepartmentType.Hospital,
	hppd: 0,
	hppd_target: uniformHppdTarget(0),
	ppd: 1,
	min_valid_hppd_percent: 0,
	max_valid_hppd_percent: 0,
	roles: [],
	partial_block_shifts: { default: [] },
	full_shift_times: { default: [] },
	jobShiftTimes: [],
	master_schedule_weeks: 2,
	shift_types: [ShiftType.Day, ShiftType.Night],
	can_view_nurses: false,
	prn_cycle_duration_days: 0,
	role_groups: {},
	masterScheduleV2Enabled: false,
	default_role: undefined,
	special_nurses: {},
	department_wage_config: getDepartmentWageConfig(undefined),
	is_readonly: false,
	hide_wage: false,
	disable_edit_master_schedule: false,
	allowed_holidays: [...DEFAULT_ALLOWED_HOLIDAYS],
	holiday_boundaries: { startHour: 6, endHour: 18 },
	day_shift_boundaries: { startHour: 6, endHour: 18 },
	weekend_boundaries: { startDay: 5, startHour: 18, endDay: 1, endHour: 6 },
	week_start_day: DEFAULT_WEEK_START_DAY,
	isSynergyMode: false,
	callOffBypassHoursBeforeShiftBedside: 6,
	callOffBypassHoursAfterStartBedside: 1,
	callOffBypassHoursBeforeShiftAdmin: 24,
	callOffBypassHoursAfterStartAdmin: 1,
	dayStart: "04:00",
	// DAT-527: null = payroll clock not decoupled from dayStart.
	payrollStartTime: null,
	censusIntervals: null,
	hoursRateConfig: [],
	modify_user: false,
	statsMode: StatsMode.PPD_HPPD,
	removeUnionStaffWarning: RemoveUnionStaffWarning.None,
	early_departure_minutes: 60,
	late_arrival_minutes: 60,
	shift_delta_minutes: 120,
	scheduled_shift_delta_minutes: 120,
	shift_delta_threshold_hours: 2,
	departmentDataHistoryWeeks: 5,
	autoCreateScheduleWeeksAhead: 8,
} as const satisfies Department;

/**
 * This section is used to redirect old routes without departmentId to new routes with departmentId
 */
export const EXCLUDED_ROUTES_FROM_DEPT_ID_REDIRECT = [
	/** Permenant */
	"/",
	"/login",
	"/forgot-password",
	"/create-account",
	"/reset-password",
	"/otp",
	"/mfa",
	"/404",
	"/email-verification",
	/** To be removed */
	"/my-schedule",
	"/annie",
	"/open-shifts",
	"/self-scheduling",
	"/notifications",
	"/docs",
	"/ops-backoffice",
	"/hiring-chat",
	"/careers",
] as const satisfies `/${string}`[];
